import {
  AFTER_WELCOME_PARAM,
  WELCOME_SEEN_PARAM
} from '../../lib/ab-tests/welcomeSplash';

export function afterWelcomePath(search: string) {
  const currentSearch = new URLSearchParams(search);
  currentSearch.set(WELCOME_SEEN_PARAM, 'true');

  const afterWelcomePathname =
    currentSearch.get(AFTER_WELCOME_PARAM) || 'signup';
  currentSearch.delete(AFTER_WELCOME_PARAM);

  return `${afterWelcomePathname}?${currentSearch.toString()}`;
}
